export default "__VITE_ASSET__BOQKvXvC__"